module.exports = __webpack_public_path__ + "img/jesse-lawler.382e9f97.jpg";